<script setup lang="ts">
import { SunIcon, MoonIcon } from '@heroicons/vue/24/solid';
import Button from '../../components/design-system/button.vue';
const colorMode = useColorMode();
const { $trackEvent } = useNuxtApp();

const toggleDark = () => {
  if (colorMode.preference === 'dark') {
    colorMode.preference = 'light';
  } else {
    colorMode.preference = 'dark';
  }
  $trackEvent('NavigationEvent', 'TOGGLE_THEME', {
    theme: colorMode?.preference,
  });
};
</script>
<template>
  <Button
    :aria-label="
      colorMode.preference === 'dark' ? $t('light-mode') : $t('dark-mode')
    "
    type="tertiary-alternative"
    @click="toggleDark()"
  >
    <component :is="colorMode.preference === 'dark' ? SunIcon : MoonIcon" />
  </Button>
</template>
